import xmlConvert from './xmlConvert';
import { Description } from '@/types/watchface';
import { ElectronApi } from '../electron.api';
import { GlobalConfig } from '../gloabl.config';
import { testAccess } from '@/utils/fs/fs-extra.utils';
import { updateProtocol } from './xmlConvert/constant';
// import { checkXml } from './utils';

export default async function (
  watchPath: string,
  basicInfo: Description,
  ast: Ast
): Promise<string | undefined> {
  const { deviceType } = basicInfo;
  const path = ElectronApi.path;
  const fs = ElectronApi.fs;
  if (!path || !fs) return;
  // checkXml(ast);
  const is16bpp = deviceType
    ? GlobalConfig['using16bppDeviceTypes'].indexOf(deviceType) !== -1
    : false;
  // 获取协议版本号
  let protocol = 8;
  let newProtocol = 0;
  const capabilityPath = path.join(watchPath, 'capability.json');
  if (await testAccess(capabilityPath)) {
    const capabilitySet = JSON.parse(
      await fs.promises.readFile(capabilityPath, 'utf-8')
    );
    const protocolNum = capabilitySet.find(
      (item: any) => item.name === 'protocol'
    )?.value[0];
    const [major, minor, patch] = protocolNum.split('.').map(Number);

    // 判断版本号是否大于等于1.9.3，大于等于1.9.3的话，bin文件使用0x00000903。9以上版本目前固件只有0900和0903两种版本
    const isVersionSupported =
      major > 1 || // 主版本号大于1
      (major === 1 && minor > 9) || // 主版本号等于1，次版本号大于9
      (major === 1 && minor === 9 && patch >= 3);
    if (isVersionSupported) {
      newProtocol = ((minor & 0xff) << 8) | (3 & 0xff); // 转换为 0x00000903 格式
    }
    protocol = Number(minor);
  }
  updateProtocol(protocol);

  const resourcePath = path.join(watchPath, 'resources');
  const originBinParts = await xmlConvert(
    ast,
    basicInfo,
    resourcePath,
    is16bpp,
    newProtocol > 0 ? newProtocol : undefined
  );
  const binFilePath = path.join(watchPath, 'resource.bin');

  // 使用同一个 fd 分块写入，避免 Windows EBUSY（多次 open/close），也避免 Buffer.concat 的内存拷贝
  const fd = fs.openSync(binFilePath, 'w');
  try {
    for (const part of originBinParts) {
      fs.writeSync(fd, part);
    }
  } finally {
    fs.closeSync(fd);
  }
  return binFilePath;
}
